import { render } from "./Plus.vue?vue&type=template&id=020f25b8&scoped=true"
import script from "./Plus.vue?vue&type=script&lang=js"
export * from "./Plus.vue?vue&type=script&lang=js"

import "./Plus.vue?vue&type=style&index=0&id=020f25b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020f25b8"]])

export default __exports__